import 'remixicon/fonts/remixicon.css';
import './lib/analytics/app';

import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './app';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
